import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";
import { useTicketSize } from "../ticket-size";
import type { SparkPoint } from "./shared";

export interface IndustryTierCounts {
  high: number;
  total: number;
  tierCounts: Array<{ tier: string; count: number }>; // High / Medium / Low
}

export interface WatchlistSummary {
  specialMention: {
    exposure: string;
    trend: { value: string; direction: "up" | "down" | "flat" };
    sparkline: SparkPoint[]; // SM % of book, recent months
    /** The file date the exposure is read at (yyyy-MM-dd): the card says "on <date>". */
    fileDate: string | null;
    /** The month the trend is measured against ("Jul 2026"); null when there is no trend. */
    trendVs: string | null;
    /** Where "Special Mention and Worse" starts, in percent (the APD grid's lowest lower limit for it); null when the grid has none. */
    thresholdPct: number | null;
  };
  // null when epd_contract has no rows. Render an empty state, not a fabricated stat.
  epd: {
    contracts: number;
    exposure: string;
    sparkline: SparkPoint[]; // monthly EPD count
  } | null;
  // null until macro_sensitivity is wired up -- same reasoning as epd above.
  macroExposure: {
    asset: IndustryTierCounts;
    borrower: IndustryTierCounts;
  } | null;
}

export function useWatchlist() {
  const { ticket } = useTicketSize();
  return useQuery({
    queryKey: ["watchlist", ticket ?? "all"],
    queryFn: () => apiGet<WatchlistSummary>("/watchlist", { ticket }),
  });
}
